import React from "react";

import { Controller, useFormContext } from "react-hook-form";
import htmlText from "../htmlText";
import {
  Checkbox,
  ListItemText,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const PracticeInformation = () => {
  const {
    control,
    formState: { errors },
    trigger,
    getValues,
  } = useFormContext();
  const { practice } = getValues();

  return (
    <div>
      <Grid container style={{ marginTop: 10 }}>
        <Grid item xs={6}>
          <p className="required">Practice Name</p>
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="practice.practice_name"
            control={control}
            rules={{ required: htmlText.thisFieldIsRequired }}
            render={({ field }) => (
              <>
                <TextField
                  required
                  fullWidth
                  size="small"
                  sx={{ marginBottom: 0 }}
                  {...field}
                  error={Boolean(errors?.practice?.practice_name)}
                  onBlur={() => trigger("practice.practice_name")}
                />
                {errors?.practice?.practice_name?.message && (
                  <FormHelperText
                    error={Boolean(errors?.practice?.practice_name)}
                  >
                    {htmlText.thisFieldIsRequired}
                  </FormHelperText>
                )}
              </>
            )}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 10 }}>
        <Grid item xs={6}>
          <p>NPI</p>
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="practice.npi_primary"
            control={control}
            rules={{
              required: false,
              pattern: {
                value: /^\d{10}$/,
                message: "NPI should be 10 digits",
              },
            }}
            render={({ field }) => (
              <>
                <TextField
                  fullWidth
                  size="small"
                  sx={{ marginBottom: 0 }}
                  {...field}
                  error={Boolean(errors?.practice?.npi_primary)}
                  onBlur={() => trigger("practice.npi_primary")}
                />
                {errors?.practice?.npi_primary?.message && (
                  <FormHelperText
                    error={Boolean(errors?.practice?.npi_primary)}
                  >
                    {errors?.practice?.npi_primary?.message}
                  </FormHelperText>
                )}
              </>
            )}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 10 }}>
        <Grid item xs={6}>
          <p>Status</p>
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="practice.status"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  variant="standard"
                  native
                  style={{ width: "100%" }}
                  {...field}
                >
                  <option value=""></option>
                  {["Active", "Trial"].map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </Select>
              </>
            )}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 10 }}>
        <Grid item xs={6}>
          <p>Subscription</p>
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="practice.subscription_type"
            control={control}
            render={({ field: { onChange, value, name, ref } }) => (
              <Select
                id="records"
                variant="outlined"
                name={name}
                ref={ref}
                onChange={onChange}
                multiple
                fullWidth
                defaultValue={practice.subscription_type || ["Provider"]}
                renderValue={(selectedRecords) =>
                  selectedRecords &&
                  selectedRecords.map((name) => name).join(", ")
                }
              >
                {["Provider", "Billing", "Scribe", "Answering service"].map(
                  (record) => (
                    <MenuItem key={record} value={record}>
                      <Checkbox checked={value.includes(record)} />
                      <ListItemText primary={record} />
                    </MenuItem>
                  )
                )}
              </Select>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};
export default PracticeInformation;
